// extracted by mini-css-extract-plugin
module.exports =  {"fileIcon":"gUKhu2OV"};